import { render, staticRenderFns } from "./board-header-filter.vue?vue&type=template&id=2cd0e5c6&"
import script from "./board-header-filter.vue?vue&type=script&lang=js&"
export * from "./board-header-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports